import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Icon,
  useToast,
  Tooltip,
} from "@chakra-ui/react";
import { ArrowsDownUp } from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";
import { Silabus } from "../../const/types";
import cr from "../../lib/request";

type Props = {
  silabus: Silabus[];
  setSilabus: (newSilabus: Silabus[]) => void;
  data: Silabus;
  currentIndex: number;
  orderLoading: boolean;
  setOrderLoading: (newOrderLoading: boolean) => void;
};

export default function OrderSilabus({
  silabus,
  setSilabus,
  data,
  currentIndex,
  orderLoading,
  setOrderLoading,
}: Props) {
  const changeOrder = (currentIndex: number, newIndex: number) => {
    if (currentIndex === newIndex) {
      return;
    }

    const updatedSilabus = [...silabus];

    // Temukan item yang akan dipindahkan
    const movedItem = updatedSilabus.find((_, i) => i + 1 === currentIndex);

    if (!movedItem) {
      return; // Tidak ada item dengan level yang sesuai
    }

    // Tentukan indeks item yang akan dipindahkan
    const movedIndex = updatedSilabus.findIndex(
      (_, i) => i + 1 === currentIndex
    );

    // Hapus item dari posisi sebelumnya
    updatedSilabus.splice(movedIndex, 1);

    // Sisipkan item ke posisi baru
    updatedSilabus.splice(newIndex - 1, 0, movedItem);

    // Update level untuk setiap item
    updatedSilabus.forEach((item, index) => {
      item.level = index + 1;
    });

    console.log(updatedSilabus);

    setSilabus(updatedSilabus);

    setOrderLoading(true);
    const url = `api/course/${data.course_id}/silabusorder`;
    const payload = {
      silabus_order: JSON.stringify(updatedSilabus.map((item) => item.id)),
    };

    cr.post(url, payload)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r?.data?.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setOrderLoading(false);
      });
  };

  const toast = useToast();

  return (
    <Menu isLazy>
      <Tooltip
        label={
          currentIndex === 1
            ? "Urutan kurikulum yang pertama tidak bisa diubah guna kestabilan sistem"
            : ""
        }
      >
        <MenuButton
          as={IconButton}
          aria-label="change order button"
          ml={2}
          icon={<Icon as={ArrowsDownUp} fontSize={iconSize} />}
          variant={"outline"}
          colorScheme="ap"
          className="clicky"
          isDisabled={silabus.length <= 1 || currentIndex === 1 ? true : false}
          isLoading={orderLoading}
        />
      </Tooltip>

      <MenuList minW={"40px"}>
        {silabus.map((_, i) => {
          const ok = currentIndex !== i + 1 && i + 1 !== 1;

          return (
            ok && (
              <MenuItem
                key={i}
                px={"14px"}
                onClick={() => {
                  changeOrder(currentIndex, i + 1);
                }}
              >
                {i + 1}
              </MenuItem>
            )
          );
        })}
      </MenuList>
    </Menu>
  );
}
